import de from './de';
import en from './en';
import es from './es';
import fr from './fr';
import it from './it';
import nl from './nl';
import pl from './pl';
import pt from './pt';
import da from './da';
import sv from './sv';
import fi from './fi';
import tr from './tr';
import no from './no';

export default { de, en, es, fr, it, pt, pl, nl, da, sv, fi, tr, no };
